import React from "react";

function OpenGraphInfo({ data, className = "", imageOnly = false }) {
  let link = data?.ogUrl ?? data?.requestUrl ?? data?.sourceLink;
  console.log("11111");

  // If ogUrl is somehow set but isn't a link.. e.g. "undefined"
  // if(!validator.isURL(link))
  //   link = data?.sourceLink;
  // console.log("2222");

  // if(!link.startsWith('http'))
  //   link = 'https://' + link;
  // console.log("3333");
  if (link) {
    try {
      const url = new URL(link);
      url.search = "";
      url.hash = "";
      link = url.toString();
    } catch {
      link = data?.requestUrl ?? data?.sourceLink ?? null;
    }
  }

  // let ogTitle = data?.ogTitle ?? link;
  let ogDescription = data?.ogDescription ?? link;

  // if(ogTitle?.length >= 125)
  //   ogTitle = `${ogTitle?.slice(0, 122)}...`;

  if (ogDescription?.length >= 200)
    ogDescription = `${ogDescription?.slice(0, 197)}...`;

  // If imageOnly is requested, render only the OG image (if present) and nothing else.
  if (imageOnly) {
    if (!data?.ogImage?.[0]) return null;
    const img = data.ogImage[0];
    return (
      <div className={`overflow-hidden rounded-lg ${className}`}>
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <img
              src={img.url}
              alt={img.alt || img.url}
              className="w-full max-h-52 object-contain"
            />
          </a>
        ) : (
          <img
            src={img.url}
            alt={img.alt || img.url}
            className="w-full max-h-52 object-contain"
          />
        )}
      </div>
    );
  }

  return (
    <div className={`border bg-white p-4 rounded-lg shadow-md ${className}`}>
      {/* <h2 className="font-semibold text-sm">{ogTitle}</h2> */}
      {/* <a
        target="_blank"
        rel="noopener noreferrer"
        href={link}
        className="text-blue-500 hover:underline break-all text-xs line-clamp-2"
      >
        {link}
      </a> */}
      {ogDescription && (
        <p className="mt-2 break-words text-xs">{ogDescription}</p>
      )}
      {data?.ogSiteName && (
        <p className="mt-2 break-words text-xs truncate text-nowrap">
          <strong>Site:</strong> {data?.ogSiteName}
        </p>
      )}
      {data?.ogImage?.[0] && (
        <div className="relative overflow-hidden mt-2 rounded-lg">
          <img
            src={data?.ogImage?.[0]?.url}
            alt={data?.ogImage?.[0]?.alt}
            className="og-image w-full max-h-52 object-contain"
          />
        </div>
      )}
    </div>
  );
}

export default OpenGraphInfo;
